import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {DWPFileContext} from "./context/DWPUploadContext";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {RouteStageContext} from "../stageStatus/context/RouteStageContext";
import {StageFilterContext} from "../stageStatus/context/StageFilterContext";

const DWPUpload = () => {
    const {dispatchDWP} = useContext(DWPFileContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {dispatch} = useContext(RouteStageContext)
    const {viewModelF, dispatchF} = useContext(StageFilterContext)

    const hiddenFileInput = React.useRef(null);

    const uploadDWP = () => {
        hiddenFileInput.current.click();
    }

    useEffect(() => {
        dispatchDWP({
            type: 'LOAD_DWP_INFO', data: {
                baseUrl: configViewModel.baseUrl,
                dispatcher: dispatchDWP,
                stationConfig: configViewModel.stationConfig
            }
        });
    }, []);

    const uploadFile = (event) => {
        const files = event.target.files;
        dispatchDWP({
            type: 'UPLOAD_DWP',
            data: {
                dispatcher: dispatchDWP,
                baseUrl: configViewModel.baseUrl,
                file: files[0],
                filterDispatcher: dispatchF,
                alertDispatch: dispatch,
                xptNodes: viewModelF.xptNodes,
                capability: configViewModel.capability,
                routeDispatcher: dispatch,
                stationConfig: configViewModel.stationConfig
            }
        });
        event.target.value = ''
    }

    return (
        <div>
            <Row spacingInset="none" spacing="none" alignmentHorizontal="left">
                <input ref={hiddenFileInput} type='file' style={{display: 'none'}} onChange={uploadFile}/>
                <Link type="secondary" onClick={uploadDWP}>
                    <FormattedMessage id="stage.uploadDwp" defaultMessage="Upload DWP"/>
                </Link>
            </Row>
        </div>
    )
}

export default DWPUpload


// WEBPACK FOOTER //
// ./src/components/fileupload/DWPUpload.js